import { X, FileText, Loader2 } from "lucide-react";
import { useFilePreview } from "../../lib/filePreview";

export function FilePreviewPanel() {
  const { path, content, language, loading, close } = useFilePreview();
  if (!path) return null;

  const filename = path.split("/").pop() || path;

  return (
    <div className="flex flex-col h-full border-l border-border bg-bg-card">
      {/* Header */}
      <div className="flex items-center gap-2 px-3 py-2 border-b border-border/50 bg-bg-subtle/50">
        <FileText className="size-4 text-accent-400 shrink-0" />
        <span className="text-small font-medium text-fg truncate flex-1" title={path}>
          {filename}
        </span>
        <span className="text-[0.65rem] text-fg-subtle font-mono">{language}</span>
        <button onClick={close} className="p-1 rounded hover:bg-bg-subtle text-fg-muted hover:text-fg">
          <X className="size-4" />
        </button>
      </div>
      {/* Content */}
      <div className="flex-1 overflow-auto p-3">
        {loading ? (
          <div className="flex items-center gap-2 text-fg-muted text-small">
            <Loader2 className="size-4 animate-spin" />
            <span>Загрузка…</span>
          </div>
        ) : (
          <pre className="text-[0.75rem] leading-relaxed font-mono text-fg-subtle whitespace-pre-wrap break-all">
            {content}
          </pre>
        )}
      </div>
      {/* Path footer */}
      <div className="px-3 py-1.5 border-t border-border/50 text-[0.65rem] text-fg-subtle font-mono truncate">
        {path}
      </div>
    </div>
  );
}
